import React from 'react'
import Logo from '../Logo'

function Header() {
  return (
<div>
          <header
            id="header"
            className="font-energetic min-h-[60px] flex flex-wrap sm:justify-start sm:flex-nowrap z-50 w-full bg-black text-sm sm:py-0 border-b-[1px] border-solid border-gray-600"
          >
            <nav
              className="relative max-w-screen-2xl w-full mx-auto sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8"
              aria-label="Global"
            >
              <div className="flex items-center justify-between flex-grow-1">
                <a
                  className="flex text-xl gap-2 items-center justify-center font-semibold text-white"
                  aria-label="Brand"
                  href="/"
                >
                  <span className="text-[16px] md:text-[20px] leading-none h-20 w-20 ">
                    {/* <img src="./Untitled design.png" alt='radio-o' /> */}
                    <Logo />
                  </span>
                </a>
                <div className="sm:hidden">
                  <button
                    type="button"
                    className="hs-collapse-toggle size-9 flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border
    border-orange-500
    text-orange-500
    hover:border-orange-500
   disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1"
                    data-hs-collapse="#navbar-collapse-with-animation"
                    aria-controls="navbar-collapse-with-animation"
                    aria-label="Toggle navigation"
                  >
                    <svg
                      className="hs-collapse-open:hidden flex-shrink-0 size-4"
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1={3} x2={21} y1={6} y2={6} />
                      <line x1={3} x2={21} y1={12} y2={12} />
                      <line x1={3} x2={21} y1={18} y2={18} />
                    </svg>
                    <svg
                      className="hs-collapse-open:block hidden flex-shrink-0 size-4"
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M18 6 6 18" />
                      <path d="m6 6 12 12" />
                    </svg>
                  </button>
                </div>
              </div>
              <div
                id="navbar-collapse-with-animation"
                className="hs-collapse hidden overflow-hidden transition-all duration-300 sm:block"
              >
                <div className="flex flex-col gap-y-4 gap-x-0 mt-5 sm:flex-row sm:items-center sm:justify-end sm:gap-y-0 sm:gap-x-7 sm:mt-0 sm:ps-7">
                  <p className="font-medium text-orange-500 sm:py-6">Home</p>
                </div>
              </div>
            </nav>
          </header>
        </div>  )
}

export default Header